import { RequestConfig } from './types';

export function buildUrl(baseUrl: string, path: string, params?: Record<string, string | number | boolean>): string {
    const url = new URL(path, baseUrl);

    if (params) {
        Object.entries(params).forEach(([key, value]) => {
            url.searchParams.append(key, String(value));
        });
    }

    return url.toString();
}

export function getDefaultHeaders(): Record<string, string> {
    return {
        'Content-Type': 'application/json',
    };
}

export function mergeHeaders(...headers: (Record<string, string> | undefined)[]): Record<string, string> {
    return Object.assign({}, ...headers.filter(Boolean));
}

export function createTimeoutSignal(timeout: number): AbortSignal {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), timeout);
    return controller.signal;
}

